var map = {
	"./admin.svg": 3916,
	"./batch.svg": 8419,
	"./create.svg": 1209,
	"./dashboard.svg": 570,
	"./ercode.svg": 6623,
	"./eye.svg": 8431,
	"./form.svg": 2962,
	"./gift.svg": 7452,
	"./icon.svg": 6931,
	"./jifen.svg": 299,
	"./link.svg": 9835,
	"./member.svg": 5935,
	"./money.svg": 1910,
	"./nav-simple.svg": 1960,
	"./nested.svg": 3593,
	"./order.svg": 5752,
	"./password.svg": 4117,
	"./register.svg": 7211,
	"./report.svg": 7026,
	"./shopping.svg": 1966,
	"./sms-vc.svg": 8587,
	"./summery.svg": 4650,
	"./system.svg": 3664,
	"./table.svg": 5695,
	"./tree.svg": 9162,
	"./user.svg": 7798
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7886;